import styled from 'styled-components';

import { lighten } from '../../../../shared/color';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.div`
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightHeavy};
  font-size: 18px;
  margin-bottom: 8px;
`;

const Desc = styled.div`
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightMedium};
  margin-bottom: 23px;

  ${props => (props.theme.isMobile ? `
    font-size: 16px;
    line-height: 20px;
  ` : `
    font-size: 18px;
    line-height: 26px;
  `)}
`;

const IDesc = styled(Desc)`
  font-style: italic;
  margin-bottom: ${props => (props.theme.isMobile ? '10px' : '21px')};
`;

const Separator = styled.div`
  height: 0px;
  border-bottom: 1px solid ${props => props.theme.secondaryColorLight};
  margin-top: 34px;
  margin-bottom: 19px;
`;

const LightSeparator = styled.div`
  height: 0px;
  border-bottom: 1px solid #EFF4F7;
  margin-top: 32px;
  margin-bottom: 15px;
`;

const ButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
`;

const Button = styled.button`
  background: ${props => props.theme.primaryColor} 0% 0% no-repeat padding-box;
  color: ${props => props.theme.bodyBackgroundColor};
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightHeavy};
  line-height: 26px;
  border-radius: 4px;
  margin-right: 5px;

  ${props => (props.theme.isMobile ? `
    font-size: 12px;
    height: 30px;
    padding: 0 12px;
  ` : `
    font-size: 14px;
    height: 35px;
    padding: 0 15px;
  `)}

  &.inactive {
    background: ${props => lighten(props.theme.primaryColor, 0.9)} 0% 0% no-repeat padding-box;
    color: ${props => props.theme.primaryColor};
  }

  &:focus {
    outline: none;
  }
`;

export {
  Button,
  ButtonGroup,
  Container,
  Desc,
  IDesc,
  Separator,
  LightSeparator,
  Title,
};
